<template>
  <div>
    <page-header title="品牌设置" description="维护自动舆情采集使用的品牌、产品和风险词">
      <el-button :loading="starting" :disabled="loading || Boolean(deletingId)" @click="start">
        {{ starting ? '启动中' : '立即采集' }}
      </el-button>
      <el-button type="primary" :disabled="loading || starting || Boolean(deletingId)" @click="open(null)">新增词条</el-button>
    </page-header>
    <el-card v-loading="loading">
      <div class="stats">
        <span>品牌词 <b>{{ brandCount }}</b></span>
        <span>产品/SKU <b>{{ skuCount }}</b></span>
        <span>风险词 <b>{{ abnormalCount }}</b></span>
        <span>启用检索词 <b>{{ searchCount }}</b></span>
      </div>
      <el-table :data="items">
        <el-table-column label="类型">
          <template slot-scope="scope">{{ typeName(scope.row.term_type) }}</template>
        </el-table-column>
        <el-table-column prop="term" label="词条" />
        <el-table-column prop="category" label="分类" />
        <el-table-column label="风险等级">
          <template slot-scope="scope">
            <span v-if="scope.row.term_type === 'abnormal'">{{ scope.row.risk_level || '未设置' }}</span>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="作用状态">
          <template slot-scope="scope">
            <el-tag :type="roleTagType(scope.row)">
              {{ roleStatus(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="检索平台" min-width="170">
          <template slot-scope="scope">
            <span v-if="scope.row.term_type === 'abnormal'" class="muted">随采集内容生效</span>
            <span v-else-if="scope.row.platforms && scope.row.platforms.length">
              {{ platformNames(scope.row.platforms) }}
            </span>
            <span v-else-if="!scope.row.search_enabled" class="muted">未参与搜索</span>
            <span v-else class="warning">未配置</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" :disabled="starting || Boolean(deletingId)" @click="open(scope.row)">编辑</el-button>
            <el-button type="text" class="delete-button" :loading="deletingId===scope.row.id" :disabled="starting || Boolean(deletingId)" @click="remove(scope.row)">{{deletingId===scope.row.id?'删除中':'删除'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <term-dialog :visible.sync="dialog" :item="editing" @success="load" />
  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
import TermDialog from './TermDialog.vue'

export default {
  components: { PageHeader, TermDialog },
  data () {
    return { items: [], loading: false, dialog: false, editing: null, starting: false, deletingId: '' }
  },
  computed: {
    brandCount () {
      return this.items.filter(item => item.term_type === 'brand').length
    },
    skuCount () {
      return this.items.filter(item => item.term_type === 'sku').length
    },
    abnormalCount () {
      return this.items.filter(item => item.term_type === 'abnormal').length
    },
    searchCount () {
      return this.items.filter(item =>
        ['brand', 'sku'].includes(item.term_type) &&
        item.active &&
        item.search_enabled
      ).length
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.items = (await yuqingApi.get('lexicon?page=1&page_size=200')).terms || []
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    open (item) {
      this.editing = item
      this.dialog = true
    },
    typeName (type) {
      return { brand: '品牌词', sku: '产品/SKU', abnormal: '风险词' }[type] || type
    },
    roleStatus (item) {
      if (item.term_type === 'abnormal') return item.active ? '参与识别' : '已停用'
      return item.active && item.search_enabled ? '参与搜索' : '未参与'
    },
    roleTagType (item) {
      if (item.term_type === 'abnormal') return item.active ? 'warning' : 'info'
      return item.active && item.search_enabled ? 'success' : 'info'
    },
    platformNames (values) {
      const names = {
        xiaohongshu: '小红书',
        weibo: '微博',
        douyin: '抖音',
        bilibili: 'B站',
        kuaishou: '快手'
      }
      return (values || []).map(value => names[value] || value).join('、')
    },
    async remove (item) {
      if (this.deletingId) return
      try {
        await this.$confirm(`确定删除词条“${item.term}”吗？删除后无法恢复。`, '删除词条', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.deletingId = item.id
        await yuqingApi.delete(`lexicon/${item.id}`)
        this.$message.success('词条已删除')
        await this.load()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(error.message || '删除失败')
      } finally {
        this.deletingId = ''
      }
    },
    async start () {
      if (this.starting || this.loading || this.deletingId) return
      this.starting = true
      try {
        await yuqingApi.post('public-opinion/refresh', {})
        this.$message.success('已按当前词条启动舆情采集')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.starting = false
      }
    }
  }
}
</script>

<style scoped>
.stats {
  display: flex;
  gap: 28px;
  padding: 0 0 18px;
  color: #606266;
}
.stats b {
  margin-left: 4px;
  color: #303133;
  font-size: 20px;
}
.delete-button {
  color: #f56c6c;
}
.muted {
  color: #909399;
}
.warning {
  color: #e6a23c;
}
</style>
